import { useConfirmMeetingMutation } from '../api';

/**
 * Hook para que el buyer confirme un slot.
 * Uso:
 *   const { confirmMeeting, isLoading } = useConfirmMeeting()
 *   await confirmMeeting({ offer_id, selected_slot_id })
 */
export function useConfirmMeeting() {
  const [trigger, { isLoading, isError, isSuccess, error, data }] = useConfirmMeetingMutation();

  return {
    confirmMeeting: trigger,
    isLoading,
    isError,
    isSuccess,
    error,
    data,
  };
}
